import {
  SET_ARE_LAST_RACE_PREFERRED_CONDITIONS,
  SET_ORDER,
  SET_ORDER_BY,
  CLEAR_FILTERS,
  SET_FILTERS,
  RacingOfficialPCPageType
} from "store/actions/racingOfficialPCPage";
import RacingOfficialPCPageState from "interfaces/RacingOfficialPCPageState";
import { defaultFiltersState } from "pages/PreferredConditionPage/RacingSecretary/PreferredConditionsFilters/filtersOptions";
import { SortOrder } from "interfaces/SortOrder";

const initialState: RacingOfficialPCPageState = {
  areLastRacePreferredConditions: undefined,
  order: SortOrder.DESC,
  orderBy: "count",
  filters: defaultFiltersState
};

export default (
  state = initialState,
  action: RacingOfficialPCPageType
): RacingOfficialPCPageState => {
  switch (action.type) {
    case SET_ARE_LAST_RACE_PREFERRED_CONDITIONS:
      return {
        ...state,
        areLastRacePreferredConditions: action.areLastRacePreferredConditions
      };
    case SET_ORDER:
      return {
        ...state,
        order: action.order
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderBy: action.orderBy
      };
    case SET_FILTERS:
      return {
        ...state,
        filters: action.filters
      };
    case CLEAR_FILTERS: {
      return {
        ...state,
        filters: initialState.filters
      };
    }
    default:
      return state;
  }
};
